const env = process.env || {};

export const API_CONFIG = {
  BASE_URL: env.REACT_APP_API_URL || env.VITE_API_URL || "",
  QUIZ_URL: env.REACT_APP_QUIZ_API_URL || env.VITE_QUIZ_URL || "",
};

export const joinApiUrl = (baseUrl, path = "") => {
  const cleanBase = String(baseUrl || "").replace(/\/+$/, "");
  const cleanPath = String(path || "").replace(/^\/+/, "");
  return cleanPath ? `${cleanBase}/${cleanPath}` : cleanBase;
};
